import React, { useState } from "react";
import { useDispatch } from "react-redux";

import * as Styled from "./styles";
import { Image, Headline, Heading6 } from "../..";

import { setChapterSlideStep } from "../../../_entities/Timeline/Timeline.actions";
import { Slides } from "../../../containers";
import useTimeout from "../../../hooks/useTimeout";

const Chapter = ({
  title,
  duration,
  loadedSlides,
  slides,
  step,
  index,
  total,
  logo,
}) => {
  const [, setShowSlide] = useState(false);
  const dispatch = useDispatch();

  const parent = {
    initial: { y: 800 },
    animate: {
      y: 0,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const child = {
    initial: { y: 800 },
    animate: {
      y: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  useTimeout(() => {
    if (step === null) {
      dispatch(setChapterSlideStep(0));
    }
    setShowSlide(true);
  }, 5000);

  return step !== null ? (
    <Slides slides={loadedSlides} step={step} />
  ) : (
    <>
      <Styled.Wrapper variants={parent} initial="initial" animate="animate">
        <Styled.Count variants={child}>
          <Heading6>
            {index + 1} / {total}
          </Heading6>
        </Styled.Count>
        <Styled.Title variants={child}>
          <Headline>{title.toUpperCase()}</Headline>
        </Styled.Title>
        <Styled.Logo variants={child}>
          <Image src={logo?.url} fallback={logo?.url} type={logo?.mime} />
        </Styled.Logo>
      </Styled.Wrapper>
    </>
  );
};

export default Chapter;
